export default __webpack_public_path__ + "static/media/1920TMBG.5de4e2c3.jpg";